
import React, { Component } from "react";

export class DataPolicy extends Component {
    render() {
        return (
            <div id="Container">

                    <div className="group-form">
                        <h3><b>ASPECTOS LEGALES</b></h3>
                    </div>
                    <div className="group-form">
                        Lea detenidamente toda la información. Si tienes alguna duda ponte en contacto con nosotros.
                    </div>
                    <div className="group-form">
                        <p>
                            LIFE CEL responderá por los perjuicios patrimoniales y extrapatrimoniales que sean
                            consecuencia directa de mi participación en los entrenamientos y se hayan producido por las
                            acciones dolosas de sus trabajadores.
                        </p>

                        <p>
                            Declaro que me encuentro en condiciones de salud mental y física para participar en el
                            entrenamiento de LIFE C.E.L, y que no presento ningún tipo de patología que me impida
                            participar. Asimismo, que toda la información que le he suministrado a LIFE C.E.L sobre mi
                            salud mental y física es totalmente fidedigna.
                        </p>

                        <p>
                            LIFE CEL no custodia mis pertenencias. Es mi responsabilidad vigilarlas. Cualquier daño,
                            pérdida o hurto de mis pertenencias no es responsabilidad de LIFE CEL, salvo que haya
                            actuado con dolo.
                        </p>

                        <p>
                            Comprendo y acepto que en el entrenamiento puede haber algunas actividades con riesgos
                            para mi integridad personal, tanto en lo corporal como mental. Riesgos como subir y bajar
                            escalas, caminar o correr sobre terreno irregular, actividades de contacto corporal con otros
                            participantes, caminar o correr sobre superficies con agua, superar obstáculos ubicados
                            horizontalmente, caídas, excoriaciones, lesiones por mecanismos cortantes, punzantes,
                            contundentes, cortocontundenes, cortopunzantes, enfermedades, infecciones y los riesgos
                            derivados de los efectos del tiempo y del ambiente, como frio, calor, humedad relativa, etc.
                            Estos riesgos, y los que resultan directa o indirectamente y estén relacionados con las
                            actividades que programa LIFE C.E.L los asumo de manera consciente, libre y voluntaria. En
                            todo momento puedo negarme a realizar cualquier actividad. Si después de que me hayan
                            explicado la actividad y haya podido evaluar los potenciales riesgos para mi integridad
                            personal decido no asumirlos, la decisión será respetada por LICE CEL. Entiendo y acepto
                            que durante el entrenamiento o como consecuencia de este, puedo sufrir daños causados por
                            mi, otro participante, un tercero, o por eventos de caso fortuito y/o fuerza mayor de los cuales
                            se pueden derivar perjuicios patrimoniales y extrapatrimoniales. Perjuicios por los cuales no es
                            responsable LIFE CEL.
                        </p>

                        <p>
                            Entiendo y acepto que para poder participar en los entrenamientos de LIFE CEL debo contar
                            con cobertura en salud, ya sea de un sistema público o privado, que garantice mi atención en
                            salud por cualquier daño personal que sufra durante los entrenamientos, o con ocasión de
                            estos.
                        </p>

                        <p>
                            Declaro que en todo momento he tenido la posibilidad de solicitar que la información sea
                            aclarada o ampliada por parte de LIFE C.E.L. Además, que toda la información suministrada
                            es veraz y completa. Comprendo que LIFE C.E.L únicamente ofrece un programa con base
                            en experiencias filosóficas y educacionales que puede o no ayudarme en mi crecimiento
                            personal. No tiene la intención de ser psicoterapia, terapia médica o un sustituto de cualquiera
                            de ellas. También que varias de las actividades conllevan emociones profundas, estrés
                            emocional, y quizás llanto, ansiedad, incomodidad física y otros efectos mentales.
                        </p>

                        <p>
                            Manifiesto de forma voluntaria, informada y libre que acepto participar en el entrenamiento de
                            LIFE C.E.L.
                        </p>
                    </div>
                    <div className="group-form">
                        <label>* ACEPTA que ha leído de manera íntegra el documento, y que además de comprenderlo acepta cada uno de los términos y condiciones del mismo</label>
                    </div>
                    <div className="group-form">
                        <h4><b><p>CONSENTIMIENTO INFORMADO...</p></b></h4>
                        <p>Yo, como participante inscrito en el Entrenamiento en Liderazgo, mayor de edad, y en pleno uso de mis condiciones mentales y físicas, suficientemente informado(a), de manera libre y voluntaria conozco y acepto las RECOMENDACIONES, REGLAS, TRATAMIENTO DE DATOS, CUESTIONARIO SOBRE SALUD, EXONERACIÓN DE RESPONSABILIDAD Y ACUERDO DE PROPIEDAD INTELECTUAL.</p>

                        <p>Declaro que en todo momento he tenido la posibilidad de que la información me sea aclarada o ampliada por parte de LIFE C.E.L. Además, que toda la información suministrada es veraz y completa.
                            Asimismo, comprendo que LIFE C.E.L únicamente ofrece un programa con base en experiencias filosóficas y educacionales que puede o no ayudarme en mi crecimiento personal. No tiene la intención de ser psicoterapia, terapia médica o un sustituto de cualquiera de ellas. También que varias de las actividades conllevan emociones profundas, estrés emocional, y quizás llanto, ansiedad, incomodidad física y otros efectos mentales.</p>

                    </div>
                    <div className="group-form">
                        <label>* Por todo lo anterior ACEPTO PARTICIPAR en el ENTRENAMIENTO DE LIFE C.E.L.</label>
                    </div>

                    <div className="group-form">
                        BIENVENIDO A NUESTRO ENTRENAMIENTO BASICO
                        Ya pronto estarás viviendo una experiencia única!
                    </div>
                </div>
        )
    }
}